import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  padding: 15px;

  Button {
    width: 100%;
    border-radius: 3px;
    font-size: 18px;
    text-transform: capitalize;
    color: ${COLORS.WHITE};
    background-color: ${COLORS.BLACK};
    margin-top: 20px;
    :hover {
      background-color: ${COLORS.BLACK};
    }
  }
  > h2 {
    color: inherit;
    font-size: 16px;
  }
  > h5 {
    color: red;
    padding: 5px 0;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 0;
  }
`;

const Information = styled.div`
  display: grid;
  grid-gap: 20px;
  position: relative;
  @media (min-width: 665px) {
    grid-template-columns: 1fr 1fr;
    /* > div {
      max-width: 333px;
    } */
  }
`;

export { Container, Information };
